namespace AgerLMS.LMS {
    export interface AddToCartResponse extends Serenity.ServiceRequest {
        UsagePeriod?: number;
        WatchCount?: number;
        ItemName?: string;
    }
}
